<template>
	<div>
		<h2>Beställ kontoutdrag</h2>

		<div v-if="orderSent" class="success-message">
			Beställning skickad!
		</div>
		<div v-else>
			<div class="account-history--order-form">
				<label>
					<div>Namn beställare</div>
					<input type="text" v-model="customerName">
				</label>

				<label>
					<div>E-post beställare</div>
					<input type="text" v-model="customerEmail">
				</label>

				<label>
					<div>Meddelande (valfritt)</div>
					<textarea v-model="message"></textarea>
				</label>

				<button type="submit" class="button" :class="{disabled: ! isValid()}" @click="order">Skicka</button>
			</div>

		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default {
	name: 'invoice-copy',

	props: ['userData'],

	data: function () {
		return {
			customerName: '',
			customerEmail: '',
			message: '',
			errorResponse: null,
			errors: [],
			orderSent: false,
			sending: false,
		}
	},

	mounted: function () {
		this.customerEmail = this.userData.contact_email
		this.customerName = this.userData.contact_person
	},

	methods: {
		isValid: function () {
			if (this.customerName.length == 0)
			{
				return false
			}

			if (this.sending)
			{
				return false
			}

			if (!String(this.customerEmail).toLowerCase().match(
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			))
			{
				return false
			}

			return true
		},

		order: function () {
			if (! this.isValid())
			{
				return
			}

			let data = {
				customer_name: this.customerName,
				customer_email: this.customerEmail,
				message: this.message,
			}

			let options = {
				credentials: true,
			}

			this.sending = true

			this.$http.post(window.pressadminBaseUrl + '/accounts-receivable/account-history', data, options).then(function (response) {
				if (response.status == 200)
				{
					this.orderSent = true
					this.sending = false
				}
			}, function (response) {

			})

			if (typeof ga === 'function')
			{
				ga.getAll()[0].send('event', {
					eventCategory: 'ResellerUsers',
					eventAction: 'Order',
					eventLabel: 'AccountHistory',
				})
			}
		},
	},
}
</script>

<style scoped>
h2 {
	margin-top: 10px;
	margin-bottom: 25px;
}

label {
	font-weight: bold;
	font-size: 18px;
	line-height: 24px;
	margin-bottom: 10px;

	display: block;
	margin-top: 15px;
}

input[type="text"], textarea {
	width: 250px;
	display: block;
	padding: 14px 20px;
	font-size: 18px;
	line-height: 24px;
	margin-bottom: 30px;
	outline: 0;
}

textarea {
	height: 150px;
}

button.disabled:hover {
	text-decoration: none;
}

button.disabled {
	opacity: 0.5;
	cursor: inherit;
}

.success-message {
	margin-bottom: 40px;
}

.account-history--order-form {
	margin-bottom: 40px;
}
</style>